export function removePunctuation(string1: string): string {
    const punctuationRegex = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;
    string1 = string1.replace(punctuationRegex, '');
    return string1;
}